
import React from 'react';
import { Row, Col, Tooltip } from 'antd';
import { FaInfoCircle } from 'react-icons/fa';

const FareBreakdownCard = ({
    flightDetails,
    convenienceCharge,
    calculatedFee,
    applyDiscountShow,
    discountAmountOffer,
    finalTotal,
    mealTotalAmount,
    mealTotalAmountRetrun,
    totalAmount,
    totalAmountReturn,
    totalSeatsPrice,
    totalSeatsPriceReturn
}) => {
    const fareRules = flightDetails?.flightDetails?.fareRules;

    console.log('finalTotal', finalTotal);
    return (
        convenienceCharge && (
            <div className="traveller-card">
                <Row gutter={16} style={{ overflowY: 'auto', maxHeight: '420px', padding: '5px 0' }}>
                    <Col xs={24}>
                        <h3 className="mb-2 fw-bold">Payment  Summary </h3>
                        <div className="card traveller-info-card">
                            <div className="card-body">
                                {fareRules?.ADULT > 0 && (
                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span>{fareRules?.ADULT === 1 ? 'Adult' : 'Adults'} * {fareRules?.ADULT} :</span>
                                        <strong>₹ {fareRules?.ADULT_BF || 0}</strong>
                                    </p>
                                )}
                                {fareRules?.CHILD > 0 && (
                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span>{fareRules?.CHILD === 1 ? 'Child' : 'Children'} * {fareRules?.CHILD} :</span>
                                        <strong>₹ {fareRules?.CHILD_BF || 0}</strong>
                                    </p>
                                )}

                                {fareRules?.INFANT > 0 && (
                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span>{fareRules?.INFANT === 1 ? 'Infant' : 'Infants'} * {fareRules?.INFANT} :</span>
                                        <strong>₹ {fareRules?.INFANT_BF || 0}</strong>
                                    </p>
                                )}

                                <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                    <span>Tax & Surcharges:</span>
                                    <strong>₹ {fareRules?.taxFare}</strong>
                                </p>


                                {(totalSeatsPrice > 0 || totalSeatsPriceReturn > 0) && (
                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span>Seats:</span>
                                        <strong>₹ {totalSeatsPrice + totalSeatsPriceReturn}</strong>
                                    </p>
                                )}

                                {(mealTotalAmount > 0 || mealTotalAmountRetrun > 0) && (
                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span>Meal:</span>
                                        <strong>₹ {mealTotalAmount + mealTotalAmountRetrun}</strong>
                                    </p>
                                )}

                                {(totalAmount > 0 || totalAmountReturn > 0) && (
                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span>Baggage:</span>
                                        <strong>₹ {totalAmount + totalAmountReturn}</strong>
                                    </p>
                                )}


                                <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                    <span className="d-flex justify-content-between align-items-center">
                                        Other
                                        <Tooltip title={`${convenienceCharge?.[0]?.title}`}>
                                            <FaInfoCircle className="mx-1" />
                                        </Tooltip>
                                        :
                                    </span>
                                    <strong>₹ {Math.round(calculatedFee)}</strong>
                                </p>

                                {applyDiscountShow && discountAmountOffer > 0 && (
                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span>Discount</span>
                                        <strong className="text-danger">₹ {Math.round(discountAmountOffer)}</strong>
                                    </p>
                                )}
                                <p className="d-flex align-items-center justify-content-between text-center mt-2 bg-light-success py-2 rounded">
                                    <h3 className='d-flex justify-content-between'>Total:</h3>
                                    <h3 className='d-flex justify-content-between'>₹ {Math.round(finalTotal - Number(discountAmountOffer))}</h3>
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    );
};

export default FareBreakdownCard;
